"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _shared = _interopRequireDefault(require("../_shared"));

// eslint-disable-next-line import/no-anonymous-default-export
var _default = {
  cssVars: "\n    :root {\n      ".concat(_shared["default"], "\n      --sans-serif:\n        'helvetica neue',\n        -apple-system, BlinkMacSystemFont,\n        'avenir next', avenir,\n        helvetica,\n        ubuntu,\n        noto,\n        'segoe ui',\n        arial,\n        sans-serif;\n      --serif: Baskerville, georgia, serif;\n      --code: consolas, monaco, monospace;\n      --black: #000000;\n      --near-black: #3e3e3e;\n      --navy: #001b44;\n      --dark-blue: #031f73;\n      --pacific-blue: #2865d7;\n      --blue: #3060af;\n      --light-blue: #3455db;\n      --lightest-blue: #417ca5;\n      --outline-blue: #286fad;\n      --alice-blue: #eafaff;\n      --washed-blue: #f2f5f8;\n      --dark-red: #871a1a;\n      --red: #b33c29;\n      --light-red: #fcdfdc;\n      --orange: #c05717;\n      --dark-orange: #cb4814;\n      --light-orange: #fed4B9;\n      --green: #3c763d;\n      --light-green: #eefcdc;\n      --gold: #f6a623;\n      --yellow: #d4b019;\n      --light-yellow: #fbf1a9;\n      --dark-gray: #3b4351;\n      --gray: #6d6d6d;\n      --mid-gray: #d8d8d8;\n      --light-gray: #f0f0f0;\n      --near-white: #f6f6f6;\n      --white: #ffffff;\n    }\n  "),
  name: 'American Blinds',
  backgroundColor: 'bg-white',
  accordion: {
    accordion: 'ba b--mid-gray shadow-1',
    animateContentDisplay: true,
    item: {
      content: 'pa3',
      title: {
        base: {
          heading: {
            wrapper: 'f3',
            text: ''
          },
          normal: {
            wrapper: 'bb b--mid-gray',
            text: ''
          }
        },
        collapsed: 'bg-light-gray',
        expanded: 'bg-white',
        collapsedAlternate: 'bg-light-gray',
        expandedAlternate: 'bg-white',
        padding: 'pa3',
        lastItemClosedStyle: 'bn',
        toggle: {
          color: 'black',
          icon: 'MdExpandMore',
          position: 'right',
          css: {
            collapsed: "\n              transform: rotate(0);\n            ",
            expanded: "\n              transform: rotate(180deg);\n            "
          }
        }
      }
    }
  },
  alert: {
    base: 'ba br3 items-start',
    icons: {
      error: {
        color: 'red',
        vector: 'MdErrorOutline'
      },
      success: {
        color: 'green',
        vector: 'MdCheckCircle'
      },
      warning: {
        color: 'yellow',
        vector: 'MdErrorOutline'
      }
    },
    spacing: 'pa2 pa3-ns mb3',
    types: {
      error: 'near-black b--red bg-light-red',
      primary: 'near-black b--pacific-blue bg-alice-blue',
      secondary: 'near-black b--gray bg-light-gray',
      success: 'near-black b--green bg-light-green',
      warning: 'near-black b--yellow bg-light-yellow'
    },
    typography: 'sans-serif f6 f5-ns'
  },
  avatar: {
    color: 'blue',
    size: '200px'
  },
  badges: [],
  banner: {
    background: 'var(--white)',
    border: '1px solid var(--mid-gray)',
    heading: {
      fontWeight: '700',
      fontSize: '3rem',
      lineHeight: '4.25rem',
      paddingBottom: '10px'
    },
    subHeading: {
      fontWeight: '400',
      fontSize: '1rem',
      lineHeight: '22px',
      paddingBottom: '25px'
    },
    anchor: {
      padding: '0 5px',
      textDecoration: 'underline',
      textDecorationLine: 'underline',
      color: 'var(--blue)'
    },
    imageBox: {
      borderColor: 'var(--mid-gray)',
      backgroundColor: 'var(--light-gray)'
    },
    imageBoxDragAccept: {
      borderColor: 'var(--green)'
    },
    imageBoxDragReject: {
      borderColor: 'var(--red)'
    },
    imageBoxFocused: {
      borderColor: 'var(--blue)'
    }
  },
  breadcrumbs: {
    delimiter: '‹',
    fontSize: 'f5',
    linkColor: 'blue',
    maxWidth: '1240px',
    isVisible: false
  },
  brightcoveplayer: 'v6wh9Bpou',
  button: {
    base: 'ttu',
    hoverBackgroundColor: 'rgba(0, 0, 0, 0.15)',
    scaleOnHover: false,
    sizes: {
      normal: 'ph4 pv3 f6',
      small: 'ph3 pv2 f7'
    },
    disabled: {
      appearance: 'b--gray bg-gray',
      text: 'white',
      outline: {
        appearance: 'b--gray bg-transparent',
        text: 'gray'
      }
    },
    primary: {
      text: 'white',
      appearance: 'bg-near-black b--near-black',
      outline: {
        appearance: 'bg-transparent b--near-black hover-bg-near-black hover-white',
        text: 'near-black'
      },
      overrides: ''
    },
    secondary: {
      text: 'white',
      appearance: 'bg-dark-red b--dark-red',
      outline: {
        text: 'dark-red',
        appearance: 'bg-transparent b--dark-red'
      }
    },
    tertiary: {
      text: 'white',
      appearance: 'bg-navy b--navy',
      outline: {
        text: 'navy',
        appearance: 'bg-transparent b--navy'
      }
    },
    alert: {
      appearance: 'bg-red b--red',
      text: 'white underline',
      outline: {
        appearance: 'bg-transparent b--red',
        text: 'red'
      }
    }
  },
  table: {
    headerCell: 'fw5',
    size: {
      normal: {
        cellSize: 'pa2',
        headerCellSize: 'pa2'
      },
      large: {
        cellSize: 'pa3',
        headerCellSize: 'pa3'
      }
    },
    type: {
      standard: {
        cell: {
          tachyons: 'bt b--mid-gray',
          css: ''
        },
        row: {},
        rowBgColor: 'bg-white'
      },
      stripes: {
        cell: {
          tachyons: '',
          css: ''
        },
        row: {},
        rowBgColor: 'bg-light-gray'
      }
    },
    typography: 'sans-serif f5'
  },
  checkbox: {
    checkboxBorderColor: 'mid-gray',
    checkboxBorderRadius: '0px',
    checkboxBorderWidth: '1px',
    checkboxColorChecked: 'gray',
    checkboxColorDisabled: 'mid-gray',
    checkboxColorHover: 'mid-gray',
    checkboxSize: '22px',
    checkmarkColor: 'white',
    checkmarkPosition: 'left: 8px; top: 4px; width: 5px; height: 10px;',
    fontSize: '16px',
    textColorDisabled: 'gray',
    textLeftOffset: '2rem',
    textTopOffset: '3px'
  },
  configurator: {
    enablePayPal: true,
    showExternalPromoMessage: false,
    draftBanner: {
      logoName: 'ab-logo'
    },
    global: "\n      [data-id=\"pcp\"] {\n        max-width: 1240px;\n      }\n    ",
    choice: {
      border: 'bw2 br3',
      maxWidth: 'mw4'
    },
    choiceContainer: {
      borderRadius: '6px',
      boxShadow: '0px 0px 10px 0px #1c28331a',
      borderWidth: '2px',
      display: 'block',
      justifyContent: 'space-between',
      padding: '4px',
      paddingLeft: '5px',
      paddingBottom: '10px',
      zoomImage: {
        tachyons: "right-0",
        css: ""
      }
    },
    option: {
      base: 'relative-ns br3-ns bn ba-ns bw2-ns flex-shrink-0',
      dictionaryTermBackgroundColor: 'bg-light-blue',
      dictionaryTermColor: 'near-black',
      dictionaryTermIconColor: 'light-blue',
      image: 'br2',
      selectedIcon: 'light-blue',
      selectedText: 'near-black',
      selectedLabel: 'near-black',
      sizeGroup: 'flex-wrap flex-nowrap-ns',
      showDivider: true,
      title: {
        base: 'f3 fw7 pt3 pr3 ttc',
        border: ''
      }
    },
    price: {
      addsPrice: 'black',
      text: 'red'
    },
    productInfo: {
      price: {
        dimensions: false
      }
    },
    promo: 'red',
    size: {
      showHelpText: false
    },
    ctaLabelsAlignments: 'justify-between',
    summary: {
      background: 'bg-washed-blue',
      border: 'none',
      choiceValue: 'black',
      floatingBar: {
        background: 'bg-light-gray',
        priceColor: 'black',
        promoPriceColor: 'near-black',
        savings: 'near-black',
        actionDiv: {
          height: '42px',
          btnHeight: 'h-100',
          fontsize: '16px'
        }
      },
      stickyTop: '1rem',
      tableType: 'stripes'
    }
  },
  pip: {
    preview: {
      container: {
        maxWidth: 'max-width: 350px;'
      },
      samples: {
        tachyons: 'dn db-ns'
      },
      visualizer: {
        floatingTopPosition: '9rem'
      },
      selectedSwatch: '',
      selectedSwatchTy: 'bb b--gray ',
      selectedSwatchInfo: 'pl3',
      styledInfo: 'ph3 ph4-l pb4-l',
      priceAndPromo: ''
    },
    productSpecifications: {
      adobeDownloadDisabled: []
    },
    productSummary: {
      howToGetIt: {
        variant: 'dynamic',
        "static": {
          color: 'var(--near-black)'
        }
      },
      howToGetItBorder: {
        border: 'none'
      },
      dimensionDropdowns: {
        showLabelValues: false
      },
      productInstallationCtaViewDisable: false,
      ctaHide: {
        display: 'none'
      }
    },
    productOptions: {
      showSampleOrderAlert: {
        display: 'block'
      }
    },
    productOverview: {
      exchangeDays: 15,
      mustReturnProduct: false,
      exclusiveGuarantee: true
    },
    productGallery: {
      internetNumLabel: 'Internet #'
    }
  },
  contentBox: {
    appearance: 'bg-white',
    content: 'f5',
    expandArrowColor: 'dark-red',
    title: 'f5 bb b--mid-gray'
  },
  dropdown: {
    arrowColor: 'near-black',
    arrowColorDisabled: 'gray',
    arrowVector: 'caret',
    borderBottomWidth: '2px',
    borderColor: 'b--mid-gray',
    borderWidth: '2px',
    borderRadius: 'br0',
    disabledLabel: 'near-black serif',
    focusBorderColor: 'gray',
    label: 'serif'
  },
  formComponents: {
    fontSize: {
      input: '16px',
      label: '16px'
    },
    inputDropdownHeight: {
      normal: '42px',
      small: '37px'
    }
  },
  gallery: {
    changeOnHover: true,
    useTabs: true,
    modalTabs: 'all',
    tabs: {
      border: {
        color: 'var(--light-gray)',
        width: '1px'
      },
      active: {
        color: 'var(--pacific-blue)',
        border: '4px solid var(--pacific-blue)'
      },
      padding: '0.5em',
      color: 'var(--near-black)',
      font: {
        weight: 700,
        size: '1rem',
        family: 'var(--sans-serif)'
      },
      fontWeight: 700
    },
    thumbnail: {
      remaining: {
        text: 'View More Images',
        background: 'var(--white)',
        container: 'b--light-gray ba serif black'
      },
      max: 5
    }
  },
  globalStyles: '',
  heading: {
    primary: {
      container: null,
      text: 'fw7'
    },
    font: {
      tachyons: {
        h1: 'f1',
        h2: 'f2',
        h3: 'f3',
        h4: 'f4',
        h5: 'f5',
        h6: 'f6',
        h7: 'f7'
      },
      manual: {}
    }
  },
  internalUser: {
    showEmptyCartLink: true
  },
  leadGeneration: {
    getStarted: {
      accountIcon: {
        color: 'var(--white)',
        size: '3em'
      },
      checkIcon: {
        color: 'var(--green)',
        size: '2em'
      },
      clockIcon: {
        color: 'var(--white)',
        size: '2.25em'
      },
      phoneIcon: {
        color: 'var(--orange)',
        size: '1.75em'
      }
    },
    highlighted: 'fw7 tc w-100 orange',
    howItWorks: {
      list: {
        style: "\n          content: counter(index, decimal);\n          counter-increment: index;\n          background-color: var(--orange);\n          color: var(--white);\n          display: inline-block;\n          position: absolute;\n          height: 1.75em;\n          width: 1.75em;\n          text-align: center;\n          vertical-align: middle;\n          line-height: 1.75em;\n          border-radius: 5em;",
        vertical: "left: 0;",
        horizontal: "top: -2.5em;"
      }
    },
    verifyAddress: {
      style: 'w-100 bg-light-blue',
      locationIcon: {
        color: 'blue',
        size: '1.25em'
      }
    }
  },
  legend: {
    text: 'serif'
  },
  link: {
    types: {
      anchor: {
        "default": 'black underline',
        hover: 'underline'
      },
      'high-visibility': {
        "default": 'b black',
        hover: 'underline',
        icon: {
          code: 'MdChevronRight',
          color: 'blue',
          position: 'after'
        }
      },
      standard: {
        "default": 'underline blue',
        hover: ''
      },
      remove: {
        "default": 'black no-underline b',
        hover: 'underline',
        icon: {
          code: 'MdClose',
          color: 'red',
          position: 'before'
        }
      }
    }
  },
  modal: {
    settings: {
      footer: false
    },
    borderRadius: 'br0',
    boxShadowCss: '',
    closeButton: 'hover-bg-light-gray black',
    content: {
      appearance: 'pb3 ph3',
      withTitle: 'pa3'
    },
    header: {
      appearance: 'pa2',
      withTitle: 'bb b--mid-gray'
    },
    overlayColorRgba: 'rgba(0,0,0,.8)',
    title: 'fw5 f5 h2-ns ml2 pr2'
  },
  newsletterSignUp: {
    _settings: {
      defaultMode: 'light'
    },
    buttonColor: 'secondary',
    content: {
      cta: 'Subscribe',
      prefix: undefined,
      suffix: undefined,
      titleLine1: 'SIGN UP & SAVE 25%',
      titleLine2: 'on orders of $299 or greater.'
    },
    color: {
      dark: {
        text: 'white'
      },
      light: {
        text: 'near-black'
      }
    },
    design: {
      container: 'w-100 mw6',
      title: 'f6 sans-serif'
    }
  },
  orangePay: {
    cssStylesOverrides: "\n      .flex-container {\n        font-family: Baskerville, georgia, serif;\n        padding: 0;\n      }\n      @media screen and (max-width: 375px) {\n        .flex-container .cc-expdate-cvv-wrapper {\n          display: block;\n        }\n        .form-input__security-code {\n          margin: 20px 0px;\n          width: 100%;\n        }\n      }\n      .form-input__field {\n        border: 2px solid #DADEDF;\n        margin-bottom: 0px;\n      }\n      .form-input__field:focus {\n        border-color: #6D6D6D;\n        border-width: 2px;\n      }\n      .form-input--error .form-input__field {\n        border: 2px solid #C02F1D;\n        background-image: url(\"data:image/svg+xml;utf8,%3Csvg fill='black' height='20' width='20' viewBox='0 0 286.054 286.054' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:%23C02F1D%3B' d='M143.027,0C64.04,0,0,64.04,0,143.027c0,78.996,64.04,143.027,143.027,143.027c78.996,0,143.027-64.022,143.027-143.027C286.054,64.04,222.022,0,143.027,0z M143.027,259.236c-64.183,0-116.209-52.026-116.209-116.209S78.844,26.818,143.027,26.818s116.209,52.026,116.209,116.209S207.21,259.236,143.027,259.236z M143.036,62.726c-10.244,0-17.995,5.346-17.995,13.981v79.201c0,8.644,7.75,13.972,17.995,13.972c9.994,0,17.995-5.551,17.995-13.972V76.707C161.03,68.277,153.03,62.726,143.036,62.726z M143.036,187.723c-9.842,0-17.852,8.01-17.852,17.86c0,9.833,8.01,17.843,17.852,17.843s17.843-8.01,17.843-17.843C160.878,195.732,152.878,187.723,143.036,187.723z' /%3E%3C/svg%3E\");\n        background-position: 200% 50%;\n        background-repeat: no-repeat;\n        margin-bottom: 0px;\n      }\n      .form-input-error__message {\n        font-size: 14px;\n        margin-top: 0px;\n      }\n      .form-input__label {\n        margin-bottom: 5px;\n      }\n      .form-input__label::after {\n        margin-left: 2px;\n        content: \"*\";\n        color: #B33C29;\n      }\n      .form-input__security-code input {\n        margin-top: 5px;\n      }\n      .form-input__security-code label span:before {\n        margin-left: 2px;\n        font-size: 160%;\n        color: #B33C29;\n        content: \"*\";\n      }\n      .form-input--error .form-input-error__message {\n        font-size: 14px;\n        color: #B33C29;\n      }\n      .form-input.form-input__cc {\n        margin-bottom: 15px;\n      }\n      .form-input.form-input__cc img {\n        top: 34px;\n      }\n      .form-input__security-code img {\n        top: 34px;\n      }\n      .form-input__security-code .small-font{\n        font-size: 16px;\n      }\n      #security-code-input .form-controls{\n        margin-top: 5px;\n      }\n      .form-input__label .small-font{\n        font-size: 16px;\n      }\n      .form-input__security-code label span:before {\n        font-size: 16px;\n        color: #B33C29;\n      }\n      .drop-down__title {\n        border: 2px solid #DADEDF;\n      }\n      .drop-down__title.drop-down__title--select:focus-within {\n        border-color: #707C80;\n        background: none;\n      }\n      .drop-down__title.drop-down__title--error {\n        border: 2px solid #B33C29;\n        background: none;\n      }\n      .drop-down-error__message {\n        font-size: 14px;\n        margin-top: 0px !important;\n      }\n      .drop-down__label {\n        padding-bottom: 5px;\n      }\n      .drop-down__label::after {\n        margin-left: 2px;\n        content: \"*\";\n        color: #B33C29;\n      }\n      .drop-down__title:before {\n        content: \"\";\n      }\n      .drop-down__title:after {\n        background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48px' height='48px'%3E%3Cpath fill='%23A2A2A2' d='M14.83,16.42L24,25.59l9.17-9.17L36,19.25l-12,12l-12-12L14.83,16.42z'/%3E%3C/svg%3E\");\n        background-position: right 40%;\n        background-repeat: no-repeat;\n      }\n      .expiration-date .drop-down-error__message{\n        font-size: 14px;\n        margin-top: 0px;\n        color: #B33C29;\n      }\n    ",
    borderWidth: '0px',
    formPaddingBottom: '0px',
    formPaddingTop: '0px',
    formMarginBottom: '0px',
    titleVisibility: 'hidden'
  },
  price: {
    color: 'near-black',
    currency: '$',
    displayOrder: {
      prefix: 1,
      price: 4,
      promo: 2,
      suffix: 6,
      promoDesc: 7,
      promoSavings: 3,
      stackable: 5
    },
    prefix: '',
    promo: 'flex w-100',
    savingsColor: 'red',
    showCentsDelimiter: true,
    strikethroughColor: 'gray',
    suffix: '',
    superscriptCents: false,
    superscriptCurrency: false,
    priceFontSizeSmall: 'f3'
  },
  quantity: {
    backgroundColor: 'bg-near-white',
    borderColor: 'b--mid-gray',
    borderRadius: 'br0',
    borderWeight: 'bw1',
    componentType: ''
  },
  radioButton: {
    radioButtonBackgroundColor: 'white',
    radioButtonBackgroundColorChecked: 'near-black',
    radioButtonBorderColor: 'mid-gray',
    radioButtonBorderColorChecked: 'near-black',
    radioButtonBorderWidth: '1px',
    radioButtonColorChecked: 'white',
    radioButtonColorDisabled: 'mid-gray',
    radioButtonColorHover: 'mid-gray',
    radioButtonSize: '20px',
    radioButtonColor: 'white',
    textColorDisabled: 'gray',
    textLeftOffset: '2rem',
    textTopOffset: '3px'
  },
  rightRailFlyout: {
    enabled: false,
    squareWidth: 55
  },
  selectionBox: {
    choiceSelectionBox: false,
    imageSelectionBox: false,
    borderColor: 'light-gray',
    borderColorSelected: 'near-black',
    borderRadius: 'br3',
    borderWidth: 'bw1',
    checked: {
      base: 'br-pill white absolute z-1',
      container: '',
      overrides: "\n        width: 30px;\n        height: 30px;\n        top: -0.5rem;\n        right: -0.5rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 1.2rem;\n        border: 3px solid var(--white);\n      "
    }
  },
  spinner: {
    color: 'dark-gray'
  },
  tag: {
    borderRadius: '0rem',
    primary: {
      appearance: 'b--red bg-red',
      text: 'white'
    },
    secondary: {
      appearance: 'b--light-gray bg-light-gray',
      text: 'near-black'
    }
  },
  textInput: {
    borderColor: 'b--mid-gray',
    borderColorFocus: 'b--gray',
    errorColor: 'red',
    borderWidth: '2px',
    disabledBackground: 'mid-gray',
    disabledLabel: 'dark-gray serif',
    errorMessageFontSize: '14px',
    label: 'dark-gray serif',
    showErrorIcon: false
  },
  textInputButton: {
    borderColor: 'b--mid-gray',
    borderWidth: '2px',
    borderRadius: undefined,
    fontSize: 'f5'
  },
  toggleSwitch: {
    checked: 'var(--green)',
    unchecked: 'var(--gray)'
  },
  visualizer: {
    _settings: {
      actionButtons: 'primary'
    },
    design: {
      fixedTopPosition: {
        large: '1rem',
        medium: '9rem',
        small: '9rem'
      },
      zoomOut: null
    }
  }
};
exports["default"] = _default;